import { Component, OnInit } from '@angular/core';
import { Configuration } from '../../../app.constants';
import { Router } from '@angular/router';
@Component({
  selector: 'app-glossary',
  templateUrl: './glossary.component.html',
  styleUrls: ['./glossary.component.css']
})
export class GlossaryComponent implements OnInit {

  constructor(public config:Configuration,public router:Router) { }

  ngOnInit() {
  }
  changeLink(frame){
    let url = frame.contentWindow.location.href;
    console.log(url)
    if(url.indexof('login')!=-1){
      this.router.navigate(['/login']);
    }
  }

}
